import urlService from '../services/rbata.urlService';
import parallax from '../utils/rbata.parallax';
import mediaLazyLoad from '../utils/rbata.mediaLazyLoad';
import productTileSlider from './rbata.tileSlider';

const productTileSwatches = {
    $swatches:    undefined,
    $productTile: undefined,

    replaceTile(productVariant, $oldTileWrapper) {
        productVariant.done(response => {
            const $newTile = $(response);
            productTileSwatches.handleHeroProductStyle($newTile, $oldTileWrapper);
            const newTileId       = $newTile.attr('id');
            const $newTileContent = $newTile.html();
            $oldTileWrapper.attr('id', newTileId);
            $oldTileWrapper.html($newTileContent);
        });

        productVariant.always(() => {
            parallax.reloadParallaxPool();
            mediaLazyLoad.refreshLazyLoad();
            productTileSlider.reInitOne($oldTileWrapper);
            $oldTileWrapper.removeClass('tile--loading');
        });
    },

    /**
     * This should keep the style for hero tile, we can't make change to grid after hero products and promo banners are loaded
     * @param $newTile
     * @param $oldTile
     */
    handleHeroProductStyle($newTile, $oldTile) {
        if ($oldTile.hasClass('tile__hero')) {
            $newTile.find('.tile-gallery')
                    .removeClass('intrinsic--3x4')
                    .addClass('intrinsic--3x2');
        } else {
            $newTile.find('.tile-gallery')
                    .removeClass('intrinsic--3x2')
                    .addClass('intrinsic--3x4');
        }
    },

    getSwatchVariants: ($variant) => {
        const isRestricted = window.location.href.includes("/restricted/");

        const variantData = {
            variant:     $variant.data('color-code'),
            position:    $variant.parents('.js-tile-track').data('position') ?? '',
            listingType: $variant.parents('.js-tile-track').data('listing-type') ?? '',
            listingName: $variant.parents('.js-tile-track').data('listing-name') ?? ''
        }

        const swatchUrl = isRestricted ? 'color-swatches-ambassador/' : 'color-swatches/';

        return $.get(`${urlService.getBaseUrl()}${swatchUrl}`, variantData);
    },

    onSwatchClick(event) {
        event.stopPropagation();
        event.preventDefault();

        const $this        = $(event.target);
        const $productTile = $this.parents('.tile');
        $productTile.addClass('tile--loading');
        const productVariant = productTileSwatches.getSwatchVariants($this);

        productTileSwatches.replaceTile(productVariant, $productTile);
    },

    init() {
        productTileSwatches.$productTile = $('.js-product-tile');
        productTileSwatches.$productTile.on('click', '.js-tile__swatch', this.onSwatchClick);
    },

    reInit() {
        productTileSwatches.$productTile.off('click', '.js-tile__swatch', this.onSwatchClick);
        productTileSwatches.init();
    }
}

$(() => {
    productTileSwatches.init();
})

export default productTileSwatches;

